
import React, { Fragment } from 'react'
import {AppButton,AppRow,AppGridBar,AppForm} from 'qcc'
import { Row, Icon ,Col} from 'antd';
import api, {PosLoginInput} from 'api';

export class PosApiInputContent extends React.Component<{config?:any}>{

    getFormData = () =>{
       return this.refForm.current.getFormData()
    }

    refForm = React.createRef<AppForm>();
    render () {
        let {config} = this.props;
        let {formdata,labelWidth,items,example} = config;
        return (<Row className='app-pos-api-input-content'>
            <Col span={16} className='app-pos-api-input-form'>
                <AppForm ref={this.refForm} loadingData={false} formData={formdata}>
                    <AppForm.Section labelWidth={labelWidth}>
                        {items.map((item?:{lable:string,field:string,placeholder:string,itemType:string},index?:number)=>{
                            return  <AppForm.Item key={index}
                                        label={item.lable}
                                        field={item.field}
                                        placeholder={item.placeholder}
                                    
                                        itemType={item.itemType||'input'}/>
                        })}
                    </AppForm.Section>
                </AppForm>
            </Col>
            <Col span={8} className='app-pos-api-input-example'>
                <div>示例：</div>
                <pre>{JSON.stringify(example, null, 4)}</pre>
            </Col>
    </Row>)
    }
}



// WEBPACK FOOTER //
// ./src/posapi/components/PosApiInputContent.tsx